<template>
  <footer class="relative py-8 text-white bg-orangePantone">
    <!--footer top-->
    <div
      class="max-w-screen-2xl w-full mx-auto px-5 lg:px-14 xl:px-20 2xl:px-12 pb-3.5 md:pb-4 flex flex-wrap justify-center lg:justify-between">
      <div class="w-full pb-4 mx-auto lg:mx-0 lg:w-4/12 xl:pr-9">
        <div
          class="flex flex-wrap items-center justify-center mx-auto text-center gap-x-4 md:flex-nowrap lg:flex-wrap lg:justify-start md:text-left lg:pr-12 md:pr-0">
          <!--logo-->
          <a href="https://lifeboostcoffee.com/" target="_blank"
            class="top-6 left-1/2 transform lg:translate-x-0 lg:mx-0 lg:static inline-block mb-6 xl:mb-5 2xl:mb-2.5">
            <nuxt-img class="" width="184px" loading="lazy" format="webp" height="67px"
              src="/assets/images/logo-footer.svg" alt="logo footer" />
          </a>
          <p class="text-sm leading-5 lg:pt-6" data-live-text-setting="footer_text" v-html="footerText"></p>
        </div>
      </div>
      <div
        class="relative flex flex-wrap items-center justify-end px-5 pt-3 mx-auto max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12 lg:pt-4 lg:w-8/12">
        <div
          class="flex flex-wrap items-center justify-center w-full mb-6 text-xs lg:w-auto lg:justify-start lg:text-sm lg:mb-0 md:space-x-12">
          <p class="block w-full mb-3 text-center md:w-auto md:mb-0" v-html="copyrightText"></p>
          <a :href="privacyPolicyLink" target="_blank"
            class="block w-1/2 text-center text-white md:w-auto hover:text-brownLatte" v-html="privacyPolicyText"></a>
          <a :href="termsLink" target="_blank"
            class="block w-1/2 text-center text-white md:w-auto hover:text-brownLatte" v-html="termsText"></a>
        </div>
        <div class="flex flex-wrap items-center justify-center w-full space-x-3 text-sm lg:w-auto lg:justify-end"></div>
      </div>
    </div>
    <!--footer bottom -->
  </footer>
</template>

<script setup>

const props = defineProps({
  footerText: {
    type: String,
    default: 'Helping You Achieve the Healthiest, Tastiest Cup of Coffee Possible Using Sustainable Farming & Protecting Our Wildlife'
  },
  copyrightText: {
    type: String,
    default: '2025 © Lifeboost Group Inc.'
  },
  privacyPolicyLink: {
    type: String,
    default: 'https://lifeboostcoffee.com/pages/privacy'
  },
  privacyPolicyText: {
    type: String,
    default: 'Privacy Policy'
  },
  termsLink: {
    type: String,
    default: 'https://lifeboostcoffee.com/pages/terms'
  },
  termsText: {
    type: String,
    default: 'Terms & Conditions'
  }
});

defineBuilderComponent({
  friendlyName: "Footer 2",
  inputs: [
    {
      name: 'footerText',
      type: 'richText',
      defaultValue: 'Helping You Achieve the Healthiest, Tastiest Cup of Coffee Possible Using Sustainable Farming & Protecting Our Wildlife'
    },
    {
      name: 'copyrightText',
      type: 'richText',
      defaultValue: '2025 © Lifeboost Group Inc.'
    },
    {
      name: 'privacyPolicyLink',
      type: 'text',
      defaultValue: 'https://lifeboostcoffee.com/pages/privacy'
    },
    {
      name: 'privacyPolicyText',
      type: 'richText',
      defaultValue: 'Privacy Policy'
    },
    {
      name: 'termsLink',
      type: 'text',
      defaultValue: 'https://lifeboostcoffee.com/pages/terms'
    },
    {
      name: 'termsText',
      type: 'richText',
      defaultValue: 'Terms & Conditions'
    }
  ]
});
</script>

<style scoped>
/* Your styles here */
</style>